tag app-text

	def render
		return unless data

		<self>
			if data.head
				<.title.{data.flags.join(' ')} innerHTML=(data.head or '')>
			<.body innerHTML=data.html>
			<.content>
				for child in data.children
					<app-text data=child>